// API helper for summit-membership
const API_URL = process.env.REACT_APP_API_URL || '/api';

// Use the external access-database function deployed at summit-customer-management
const ACCESS_DATABASE_URL =
  'https://admin.summitmartialartssandiego.com/.netlify/functions/access-database';

// Register a new member using the access-database function
export async function createMember(data: {
  student_first_name: string;
  student_last_name: string;
  parent_first_name?: string;
  parent_last_name?: string;
  contact_emails: string[];
  contact_phone?: string;
  source?: string;
  address_line1?: string;
  student_birthdate?: string;
  membership_type?: string;
}) {
  const res = await fetch(`${ACCESS_DATABASE_URL}/people/members`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Failed to create member');
  return res.json();
}

export async function submitWaiver(memberId: string, waiver: { waiver_text: string; signature: string }) {
  if (!memberId) throw new Error('No memberId provided');
  // Always use a relative path for Netlify Dev proxying
  const res = await fetch(`${API_URL}/public/members/${memberId}/waiver`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(waiver),
  });
  if (!res.ok) throw new Error('Failed to submit waiver');
  return res.json();
}

export async function createStripeSession(memberId: string) {
  // Always use a relative path for Netlify Dev proxying
  const res = await fetch(`${API_URL}/public/members/${memberId}/stripe-session`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!res.ok) throw new Error('Failed to create Stripe session');
  return res.json();
}

export async function getStripeCustomerInfo(memberId: string) {
  const res = await fetch(`/api/public/members/${memberId}/stripe-info`);
  if (!res.ok) throw new Error('Failed to fetch Stripe info');
  return res.json();
}

export async function fetchMembersWithAttendance() {
  const res = await fetch(
    `${ACCESS_DATABASE_URL}?withLastAttended=1`,
    { method: 'GET' }
  );
  if (!res.ok) throw new Error('Failed to fetch members');
  return res.json();
}
